/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CustomerServiceCustomerDetailsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const customerServiceCustomerDetailsEntryPoint: EntryPoint<
	CustomerServiceCustomerDetailsEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<CustomerServiceCustomerDetailsEntryPointComponent>(
		/* webpackChunkName: "async-customer-service-customer-details" */ './CustomerServiceCustomerDetailsSpaApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
